import { _POST, requestExport, type RequestExportOptions } from "@/services/request";
import {
  DakeListChannelsExportReq,
  DakeSelectionListReq,
  GoodsLibraryRequest,
  PlanListRequest,
} from "@/data-contracts";

/**
 * DakeAdmin_ChannelsExport
 *
 * /admin/ChannelsExport
 *
 * params: DakeListChannelsExportReq
 * */
const dakeListChannels = ({ params, callback }: RequestExportOptions<DakeListChannelsExportReq>) =>
  requestExport<DakeListChannelsExportReq>("/admin/ChannelsExport", {
    method: _POST,
    params,
    callback,
  });

/**
 * 商品列表导出
 *
 * /admin/product/list/export
 * params?: GoodsLibraryRequest
 * */
const productExport = ({ params, callback }: RequestExportOptions<GoodsLibraryRequest>) =>
  requestExport<GoodsLibraryRequest>("/admin/product/list/export", {
    method: _POST,
    params,
    callback,
  });

/**
 * 选品列表导出：复用 ListSelection 的筛选条件，忽略 page、size
 *
 * /admin/selection/list/export
 * */
const selectionListExport = ({ params, callback }: RequestExportOptions<DakeSelectionListReq>) =>
  requestExport<DakeSelectionListReq>("/admin/selection/list/export", {
    method: _POST,
    params,
    callback,
  });

/**
 * 计划列表导出：复用 PlanList 的筛选条件，忽略 page、size
 *
 * /admin/plan/list/export
 * */
const planListExport = ({ params, callback }: RequestExportOptions<PlanListRequest>) =>
  requestExport<PlanListRequest>("/admin/plan/list/export", {
    method: _POST,
    params,
    callback,
  });

export const exportApis = {
  dakeListChannels,
  productExport,
  selectionListExport,
  planListExport,
};
